// from https://mixitup.kunkalabs.com/learn/tutorial/advanced-filtering/, http://codepen.io/patrickkunka/pen/ltgde
// with sort code added back in
var buttonFilter = {
  
  // Declare any variables we will need as properties of the object
  
  $filters: null,
  $reset: null,
  groups: [],
  outputArray: [],
  outputString: '',
  
  // The "init" method will run on document ready and cache any jQuery objects we will need.
  
  init: function(){
    var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "buttonFilter" object so that we can share methods and properties between all parts of the object.
    
    self.$filters = $('#spoiler-card-filters');
    self.$reset = $('.filter-group-reset-link');
    self.$container = $('.spoiler-card-container');
    self.$sort = $('.sort');
    
    self.$filters.find('fieldset').each(function(){
      self.groups.push({
        $buttons: $(this).find('.filter'),
        active: ''
      });
    });
    
    self.bindHandlers();
  },
  
  // The "bindHandlers" method will listen for whenever a button is clicked. 
  
  bindHandlers: function(){
    var self = this;
    
    // Handle filter clicks
    
    self.$filters.on('click', '.filter', function(e){
      e.preventDefault();
      
      var $button = $(this);
      
      // If the button is active, remove the active class, else make active and deactivate others.
      
      $button.hasClass('active') ?
        $button.removeClass('active') :
        $button.addClass('active').siblings('.filter').removeClass('active');
      
      self.parseFilters();
    });

    self.$sort.on('change', function(e){
      e.preventDefault();
      
      var $button = $(this);
      self.$container.mixItUp('sort', $button.val());
      
    });
    
    // Handle reset click
    
    self.$reset.on('click', function(e){
      e.preventDefault();
      
      self.$filters.find('.filter').removeClass('active');
      
      self.parseFilters();
    });
  },
  
  // The parseFilters method checks which filters are active in each group:
  
  parseFilters: function(){
    var self = this;
 
    // loop through each filter group and grap the active filter from each one.
    
    for(var i = 0, group; group = self.groups[i]; i++){
      group.active = group.$buttons.filter('.active').attr('data-filter') || '';
    }
    
    self.concatenate();
  },
  
  // The "concatenate" method will crawl through each group, concatenating filters as desired:
  
  concatenate: function(){
    var self = this;
    
    self.outputString = ''; // Reset output string
    
    for(var i = 0, group; group = self.groups[i]; i++){
      self.outputString += group.active;
    }
    
    // If the output string is empty, show all rather than none:
    
    !self.outputString.length && (self.outputString = 'all'); 
    
    // ^ we can check the console here to take a look at the filter string that is produced
    
    // Send the output string to MixItUp via the 'filter' method:
    
    if(self.$container.mixItUp('isLoaded')){
      self.$container.mixItUp('filter', self.outputString);
    }
  }
};

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  buttonFilter.init();



  var mixer = $('.spoiler-card-container').mixItUp({
    animation: {
      enable: false   
    },
    controls: {
      enable: false // we won't be needing these
    },
    callbacks: {
    }
  });

	function filterByString(searchValue) {
			console.log("filter by string" + searchValue);
			if (searchValue) {
					// Use an attribute wildcard selector to check for matches

					console.log('[data-name*="' + searchValue + '" i]');
					$('.spoiler-card-container').mixItUp('filter', '[data-name*="' + searchValue + '" i]');
			} else {
					// If no searchValue, treat as filter('all')

					$('.spoiler-card-container').mixItUp('filter', "all");
			}
	}

	$(".spoiler-text-filter").keyup(function() {
			console.log("keyup");
			var searchValue;
			var keyupTimeout;


			if ($(this).val().length < 3) {
					// If the input value is less than 3 characters, don't send
					searchValue = '';
			} else {
					searchValue = $(this).val().toLowerCase().trim();
			}

			// Very basic throttling to prevent mixer thrashing. Only search
			// once 350ms has passed since the last keyup event

			clearTimeout(keyupTimeout);

			keyupTimeout = setTimeout(function() {
					filterByString(searchValue);
			}, 350);
	});

  $(".filter-group-reset-link").click(function (){
    $('.spoiler-card-container').mixItUp('filter', "all");
  });

  $(".spoiler-card-unofficial-blocker").click(function() {
    $(".spoiler-card-unofficial-blocker").hide();
  });

});
